import { THEME } from 'GlobalStyles';

const textStyle = { color: THEME.palette.text.secondary };

/** Defaults applied in dark mode only, below any option passed by the chart. */
export const DARK_CHART_DEFAULTS = {
  backgroundColor: 'transparent',
  legend: { textStyle: { color: THEME.palette.text.primary } },
  titleTextStyle: { color: THEME.palette.text.primary },
  annotations: { textStyle: { color: THEME.palette.text.primary } },
  hAxis: { textStyle, titleTextStyle: textStyle, gridlines: { color: THEME.palette.divider } },
  vAxis: { textStyle, titleTextStyle: textStyle, gridlines: { color: THEME.palette.divider } }
};
